module.exports = __webpack_public_path__ + "media/images/kids friendly-2d080a28e76f117695438c936a8f7f6e.svg";